import * as React from 'react';
import { WiSnowflakeCold } from 'react-icons/wi';
import { ReactNode } from 'react';
import { observer } from 'mobx-react';
import { t } from '../../../stores/TranslateStore';
import style from './LabelBox.module.scss';
import { JoinClassName } from '../../../utils/string';
import { LayoutProps } from '../../../constants';
import { FlexLayout, DefaultLayout } from '../../layout';

interface LabelBoxActions {
  onClick?: () => any;
  onDblClick?: () => any;
}

interface LabelBoxProps extends LabelBoxActions, LayoutProps {
  title?: string;
  /**
   * title 을 번역할지 여부. 기본값은 true 라서, 화면을 새로 만들 때 아무것도
   * 신경 쓰지 않아도 고정 라벨은 그대로 번역된다.
   *
   * title 에 레코드 값이 조금이라도 섞이면 반드시 false 로 넘겨야 한다.
   * 예를 들어 title={`건물:${model?.contbildnm}`} 이나 title={content?.contgubunnm}
   * 처럼 거래처/건물/담당자 이름, 코드값, 날짜, 행마다 달라지는 값이 들어가는
   * 경우다.
   *
   * 번역이 어떻게 동작하는지 알고 있어야 이유가 납득된다. t.T() 는 사전에 없는
   * 문구를 렌더 중에 큐에 넣어 서버로 보내고, 서버는 그 문구를 외부 번역
   * 모델에 그대로 전달한다. 그리고 결과를 언어별 사전 한 벌에 영구 저장하는데,
   * 이 사전에는 회사(테넌트) 구분이 없고 /i18n/all 로 모든 로그인 사용자에게
   * 통째로 내려간다. 즉 A 사 화면에 뜬 건물명이 외부 모델로 나가고, 그대로
   * 남아서 B 사 사용자의 브라우저에 미리 실려 버린다. 게다가 레코드 값은
   * 가짓수에 끝이 없어서 번역 요청과 사전이 무한히 불어난다.
   *
   * 정리하면 - 소스에 한국어가 그대로 박혀 있는 고정 라벨만 기본값(true)으로
   * 두고, 값이 데이터에서 오는 순간 translate={false} 를 붙인다.
   */
  translate?: boolean;
  isNeed?: boolean;
  footer?: ReactNode;
}

@observer
export class LabelBox extends React.Component<LabelBoxProps> {
  render() {
    const { translate = true } = this.props;

    return (
      <FlexLayout
        className={JoinClassName.make([style.container, this.props.className])}
        style={this.props.style}
        weight={this.props.weight}
        size={this.props.size}
        isVertical={true}
      >
        {this.props.title && <DefaultLayout className={style.title} size={22}>
          <span style={this.props.style}>{translate ? t.T(this.props.title) : this.props.title}</span>
          {this.props.isNeed && (
            <span className={style.need}>
              <WiSnowflakeCold />
            </span>
          )}
          {this.props.footer && (
            <FlexLayout
              className={style.footer}
              size={42}
              justify="end"
            >
              {this.props.footer}
            </FlexLayout>
          )}
        </DefaultLayout>}
        <FlexLayout
          className={style.textField}
          style={{
            paddingTop: this.props.title ? 4 : 8,
          }}
        >
          {this.props.children}
        </FlexLayout>
      </FlexLayout>
    );
  }
}
